import { Language } from '@openeducation/oe-rn-shared-types';

import LanguagesDao from '../dao/languages.dao';
import type { SupportedLanguageDTO } from '../interfaces';
import type { Environment } from '../interfaces/environment';

export abstract class LanguagesService {
  static async getSupportedLanguages(
    env: Environment,
    language: Language = Language.EN
  ): Promise<SupportedLanguageDTO[]> {
    const supportedLanguages = await LanguagesDao.getSupportedLanguages(
      env,
      language
    );
    return supportedLanguages;
  }

  static async getSupportedLanguageCodes(
    env: Environment,
    language?: Language
  ): Promise<Language[]> {
    const supportedLanguages = await this.getSupportedLanguages(env, language);

    return supportedLanguages.map(
      (supportedLanguage) => supportedLanguage.code
    );
  }
}
